import Module from './modal'
export default Module
